/**
 * simple相关路由
 */
import { Layout } from '@/router/constant';
import { renderImageIcon } from '@/utils/render';
import analysisIcon from '@/assets/icons/aside/analysis.png';
import { AppRouteRecordRaw } from '../types';
import I18n from '@/plugins/i18n';
const routeName = 'SimpleIndex';
const { t } = I18n.global;
const routes: Array<AppRouteRecordRaw> = [
  {
    path: '/simple',
    name: routeName,
    redirect: '/simple/index',
    component: Layout,
    meta: {
      title: t('router.simpleIndex.simpleIndex'),
      icon: renderImageIcon(analysisIcon),
      // permissions: ['dashboard_console', 'dashboard_console', 'dashboard_workplace'],
      sort: 2,
      // permissions: ['10003'],
    },
    children: [
      {
        path: 'index',
        name: `${routeName}Index`,
        meta: {
          title: t('router.simpleIndex.index'),
          icon: renderImageIcon(analysisIcon),
          // permissions: ['10003'],
          keepAlive: true,
        },
        component: () => import('@/views/simpleIndex/index/index.vue'),
      },
      {
        path: 'jescard',
        name: `${routeName}Jescard`,
        meta: {
          title: t('router.simpleIndex.jescard'),
          icon: renderImageIcon(analysisIcon),
          // permissions: ['10003'],
          keepAlive: true,
        },
        component: () => import('@/views/simpleIndex/jescard/index.vue'),
      },
      {
        path: 'top',
        name: `${routeName}Top`,
        meta: {
          title: t('router.simpleIndex.top'),
          icon: renderImageIcon(analysisIcon),
          // permissions: ['10003'],
          keepAlive: true,
        },
        component: () => import('@/views/simpleIndex/top/index.vue'),
      },
    ],
  },
];

export default routes;
